import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Col, Row, Button, Input } from "reactstrap";
import { Link } from "react-router-dom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "../views/stripeSubscription/stripeSubscriptionConfig.css";

const formatAllowanceValue = (value) => (
  value > 0 ? value : "—"
);

const formatModuleLimit = (value) => (
  value > 0 ? value : "Included"
);

const ModuleStatus = ({ enabled, label }) => (
  <div className="stripe-products-module-row">
    <i
      className={`fas fa-${enabled ? "check" : "times"}-circle stripe-products-module-icon ${
        enabled ? "text-success" : "text-danger"
      }`}
      aria-hidden="true"
    />
    <span>{label}</span>
  </div>
);

const modulesFormatter = (cell, row) => (
  <div className="stripe-products-cell-stack">
    <ModuleStatus enabled={row.music_link_enabled} label="Music Link" />
    <ModuleStatus enabled={row.link_landing_page_enabled} label="Link Landing Page" />
  </div>
);

const allowancesFormatter = (cell, row) => (
  <div className="stripe-products-cell-stack">
    <div className="stripe-products-allowance-row">
      <span className="stripe-products-allowance-label">Songs</span>
      <span>{formatAllowanceValue(row.song_limit)}</span>
    </div>
    <div className="stripe-products-allowance-row">
      <span className="stripe-products-allowance-label">Artists</span>
      <span>{formatAllowanceValue(row.artist_limit)}</span>
    </div>
    <div className="stripe-products-allowance-row">
      <span className="stripe-products-allowance-label">Music Links</span>
      <span>
        {row.music_link_enabled
          ? formatModuleLimit(row.music_link_limit)
          : "—"}
      </span>
    </div>
    <div className="stripe-products-allowance-row">
      <span className="stripe-products-allowance-label">Landing Pages</span>
      <span>
        {row.link_landing_page_enabled
          ? formatModuleLimit(row.link_landing_page_limit)
          : "—"}
      </span>
    </div>
  </div>
);

const StripeSubscriptionProductsTable = ({ tableData, featureLocked = false }) => {
  const nameFormatter = (cell, row) => (
    <>
      <span className="fontWeight700">{cell}</span>
      {row.description && (
        <div className="text-muted" style={{ fontSize: "0.85rem" }}>{row.description}</div>
      )}
    </>
  );

  const dealFormatter = (cell) => <span>{cell}%</span>;

  const actionFormatter = (cell, row) => (
    featureLocked ? (
      <Button outline color="primary" disabled>
        Edit
      </Button>
    ) : (
      <Button outline color="primary">
        <Link to={`/products/${row.id}/update/`}>Edit</Link>
      </Button>
    )
  );

  const columns = [
    {
      dataField: "name",
      text: "Plan",
      sort: false,
      formatter: nameFormatter,
      headerStyle: () => ({ width: "20%" }),
    },
    {
      dataField: "price_display",
      text: "Price",
      sort: false,
      headerStyle: () => ({ width: "11%" }),
    },
    {
      dataField: "deal_percent",
      text: "Deal",
      sort: false,
      formatter: dealFormatter,
      headerStyle: () => ({ width: "8%" }),
    },
    {
      dataField: "modules",
      text: "Modules",
      sort: false,
      formatter: modulesFormatter,
      headerStyle: () => ({ width: "17%" }),
    },
    {
      dataField: "allowances",
      text: "Allowances",
      sort: false,
      formatter: allowancesFormatter,
      headerStyle: () => ({ width: "20%" }),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: () => ({ width: "10%" }),
    },
  ];

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true,
      }}
    >
      {(props) => (
        <div className="stripe-subscription-page stripe-products-table">
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder="Search..."
                  value={props.searchProps.searchText}
                  style={{ marginBottom: 10 }}
                  onChange={(e) => props.searchProps.onSearch(e.target.value)}
                  disabled={featureLocked}
                />
              </div>
            </Col>
          </Row>

          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            noDataIndication="No products configured yet"
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default StripeSubscriptionProductsTable;
